import React from "react"
import {
  Button,
  Modal,
  Message,
} from "semantic-ui-react"
import InvoicesTable from "./InvoicesTable"
import SearchBar from "./SearchBar"
import FilterButtonsInvoices from "./FilterButtonsInvoices"

// import getInvoices from '../BankReconciliation.functions/getInvoices'

const InvoicesPopup = ({
  ...logic
} = {}) => {
  const {
    onInvoicesAmountFilterChange,
    selectedBankTransfer = {},
    matchedInvoices = [],
    onInvoicesDateFilterChange,
    isInvoicesPopupModalOpen,
    isInvoicesPopupMatchesValidatedSideMessageVisible,
    showInvoicesPopupMessageDeleted,
    onMatchSelectedInvoicesPressErrorMessage,
    onInvoiceUnmatchPress,
    onInvoiceSearchPress,
    setisInvoicesPopupModalOpen,
    onInvoiceUnmatchPressErrorMessage,
    onMatchSelectedInvoicesPress,
    selectedInvoices = [],
  } = logic
  return (
    <div className="popup-container">
      <button
        type="button"
        onClick={() => setisInvoicesPopupModalOpen(true)}
        className="manually-matched ui labeled icon violet button"
      >
        Find invoices
      </button>

      {isInvoicesPopupMatchesValidatedSideMessageVisible && (
        <Message positive>
          <Message.Header>Invoices matched successfully!</Message.Header>
        </Message>
      )}

      {/* Liste des factures validées avec bouton Delete */}
      <div className="ui segment invoices-matched">
        <h3>Matched Invoices:</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          {Array.isArray(matchedInvoices) && matchedInvoices.map((invoice, index) => {
            const {
              orderNumber = '',
              isNumberInLibelle = false,
            } = invoice || {}

            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minWidth: '48%',
                  maxWidth: '48%',
                  flex: '0 0 48%',
                  background: '#fafafa',
                  border: '1px solid #eee',
                  borderRadius: '6px',
                  marginBottom: '2px',
                  padding: '2px 6px',
                  fontSize: "0.78rem",
                  boxSizing: 'border-box',
                }}
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.78rem' }}>
                  {orderNumber + (isNumberInLibelle ? '📝' : '')}
                </span>
                <button
                  type="button"
                  className="ui icon mini circular basic button"
                  onClick={() => onInvoiceUnmatchPress({ invoice, selectedBankTransfer })}
                  title="Unmatch"
                  aria-label={`Unmatch ${orderNumber}`}
                  style={{ marginLeft: "6px", minWidth: 0, padding: '1px' }}
                >
                  <i className="close icon" style={{ fontSize: '1em', color: '#555', fontWeight: 700 }} />
                </button>
              </div>
            )
          })}
        </div>
        <span>{onInvoiceUnmatchPressErrorMessage}</span>
        {showInvoicesPopupMessageDeleted && (
          <Message negative>
            <Message.Header>Invoices deleted successfully!</Message.Header>
          </Message>
        )}
        {!Array.isArray(matchedInvoices) || matchedInvoices.length === 0 ? (
          <p>No invoices matched yet.</p>
        ) : null}
      </div>

      <Modal open={isInvoicesPopupModalOpen} onClose={() => setisInvoicesPopupModalOpen(false)} size="large">
        <Modal.Header>Invoices popup</Modal.Header>
        <Modal.Content scrolling>
          <h1>Invoices Table</h1>
          <div className="transaction-header-bottom">
            <SearchBar
              onSearch={onInvoiceSearchPress}
            />
            <FilterButtonsInvoices
              onInvoicesDateFilterChange={onInvoicesDateFilterChange}
              onInvoicesAmountFilterChange={onInvoicesAmountFilterChange}
            />
          </div>
          <br />
          <br />
          <InvoicesTable
            // invoicesPopupFilteredInvoices={invoicesPopupFilteredInvoices}
            // selectedInvoices={selectedInvoices}
            // onInvoiceCheckboxPress={onInvoiceCheckboxPress}
            // onMatchSelectedInvoicesPress={onMatchSelectedInvoicesPress}
            selectedBankTransfer={selectedBankTransfer}
            {...logic}
          />
          <div>
            {`${onMatchSelectedInvoicesPressErrorMessage}`}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            size="large"
            onClick={() => setisInvoicesPopupModalOpen(false)}
          >
            Fermer
          </Button>
          <Button
            type="button"
            color="custom-label-green"
            size="large"
            onClick={() => onMatchSelectedInvoicesPress({
              selectedInvoices,
              selectedBankTransfer,
            })}
          >
            Match selected invoice(s)
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export default InvoicesPopup
